var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button-action",class:_vm.buttonStyle},[(_vm.loading)?_c('span',{staticStyle:{"margin":"0 3px 0 -8px"}},[_c('span',{staticClass:"progress"})]):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }